import Ellipsis from '@hui-pro/ellipsis/src/ellipsis';
import EllipsisDirective from '@hui-pro/ellipsis/src/directive';

import Page from './src/page';
import PageMenu from './src/page-menu';
import PageContainer from './src/page-container';
import PageHeader from './src/page-header';
import PageContent from './src/page-content';
import PageFooter from './src/page-footer';
import PageSidebar from './src/page-sidebar';
import PageAction from './src/page-action';
import PageSearch from './src/page-search';
import PageSearchItem from './src/page-search-item';
import PageGroup from './src/page-group';
import PageTable from './src/page-table';
import PageButtonGroup from './src/page-button-group';
import PageDetail from './src/page-detail';
import PageDetailItem from './src/page-detail-item';

const install = function(Vue) {
  Vue.component(Ellipsis.name, Ellipsis);
  Vue.use(EllipsisDirective);

  Vue.component(Page.name, Page);
  Vue.component(PageMenu.name, PageMenu);
  Vue.component(PageContainer.name, PageContainer);
  Vue.component(PageHeader.name, PageHeader);
  Vue.component(PageContent.name, PageContent);
  Vue.component(PageFooter.name, PageFooter);
  Vue.component(PageSidebar.name, PageSidebar);
  Vue.component(PageAction.name, PageAction);
  Vue.component(PageSearch.name, PageSearch);
  Vue.component(PageSearchItem.name, PageSearchItem);
  Vue.component(PageGroup.name, PageGroup);
  Vue.component(PageTable.name, PageTable);
  Vue.component(PageButtonGroup.name, PageButtonGroup);
  Vue.component(PageDetail.name, PageDetail);
  Vue.component(PageDetailItem.name, PageDetailItem);
};

export default {
  install
};
